var _g, _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1302_34243)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_34243)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 11.5,
    r: 9.375,
    fill: "#8C278F",
    stroke: "#90278F",
    strokeWidth: 1.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5917 7.50822C18.5142 7.43011 18.4221 7.36811 18.3205 7.32581C18.219 7.2835 18.11 7.26172 18 7.26172C17.89 7.26172 17.7811 7.2835 17.6796 7.32581C17.578 7.36811 17.4858 7.43011 17.4084 7.50822L11.2 13.7249L8.59171 11.1082C8.51127 11.0305 8.41632 10.9694 8.31227 10.9284C8.20823 10.8874 8.09713 10.8673 7.98531 10.8692C7.87349 10.8712 7.76315 10.8951 7.66058 10.9397C7.55802 10.9843 7.46524 11.0486 7.38754 11.1291C7.30984 11.2095 7.24875 11.3044 7.20774 11.4085C7.16674 11.5125 7.14663 11.6236 7.14856 11.7354C7.1505 11.8473 7.17444 11.9576 7.21902 12.0602C7.2636 12.1627 7.32794 12.2555 7.40837 12.3332L10.6084 15.5332C10.6858 15.6113 10.778 15.6733 10.8796 15.7156C10.9811 15.7579 11.09 15.7797 11.2 15.7797C11.3101 15.7797 11.419 15.7579 11.5205 15.7156C11.6221 15.6733 11.7142 15.6113 11.7917 15.5332L18.5917 8.73322C18.6763 8.65518 18.7438 8.56047 18.79 8.45506C18.8361 8.34964 18.86 8.2358 18.86 8.12072C18.86 8.00563 18.8361 7.8918 18.79 7.78638C18.7438 7.68096 18.6763 7.58625 18.5917 7.50822Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1302_34243",
    x: 0.5,
    y: 0.25,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1302_34243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1302_34243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_34243"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.a22654ae7cf47ab757c499c91bc3b85c.svg";
export { ForwardRef as ReactComponent };